import { render, staticRenderFns } from "./PostRegister.vue?vue&type=template&id=be3e4e54&"
import script from "./PostRegister.vue?vue&type=script&lang=js&"
export * from "./PostRegister.vue?vue&type=script&lang=js&"
import style0 from "./PostRegister.vue?vue&type=style&index=0&id=be3e4e54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports